<!--
 * @Author: M.D.
 * @Date: 2019-12-18 11:15:33
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="password bShadow-5">
    <el-tabs value="gr" class="ui-tabs ui-custom-s">
      <el-tab-pane name="gr">
        <span slot="label" class="lb-txt"> 修改密码 </span>

        <!-- 表单 -->
        <div class="pwd-form-wrapper">
          <el-form ref="form" :model="pwdForm" label-position="left"  label-width="100px">
            <el-form-item label="手机号码" class="u-pwd-phone" :rules="rule.phone">
              <el-input placeholder="请输入手机号码" v-model="pwdForm.mobile" readOnly></el-input>
            </el-form-item>

              <!-- <el-form-item label="账号名称" class="u-pwd-auth-c" prop="username" :rules="rule.required">
                <el-select style="width: 100%" v-model="pwdForm.username" placeholder="请选择登录账号">
                  <el-option
                    v-for="item in accounts"
                    :key="item.username"
                    :label="item.username"
                    :value="item.username">
                  </el-option>
                </el-select>
              </el-form-item> -->

              <el-form-item label="验证码" class="u-pwd-auth-c" prop="code" :rules="rule.required">
                <auth-code :phoneNum="pwdForm.mobile" :isReg="false" @authCodeChange="setNewAuthCode"></auth-code>
              </el-form-item>

            <el-form-item label="设置新密码" prop="password" :rules="rule.pwd">
              <el-input type="password" placeholder="请输入新密码（6-20个字符）" v-model="pwdForm.password"></el-input>
            </el-form-item>

            <el-form-item label="确认密码" prop="rePassWord" :rules="repPwdValidator">
              <el-input type="password" placeholder="请再次输入新密码" v-model="pwdForm.rePassWord"></el-input>
            </el-form-item>

            <el-button class="btn" type="primary" :loading="loading" @click="onSubmit">保存修改</el-button>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import API from '@/api/usr-api'
import rule from '@/util/rule'
import AuthCode from '@/components/auth-code'
import { mapGetters } from 'vuex'
export default {
  props: {

  },
  data () {
    return {
      loading: false,
      rule,
      accounts: [],
      repPwdValidator: {
        required: true,
        validator: (rule, value, cb) => {
          if (!value) {
            return cb(new Error('确认密码不能为空'))
          } else if (this.pwdForm.password !== value) {
            return cb(new Error('两次输入的密码不一致，请检查'))
          } else {
            cb()
          }
        },
        trigger: 'blur'
      },
      pwdForm: {
        mobile: '',
        rePassWord: '',
        password: '',
        code: ''
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.pwdForm.mobile = this.userInfo.mobile
  },
  mounted () {
    // this.getMembersByMobile()
  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    onInputMobile (v) {
      const reg = /^1[3456789]\d{9}$/
      if (reg.test(v)) {
        this.getMembersByMobile()
      }
    },
    async getMembersByMobile () {
      try {
        const res = await API.getMembersByMobile({
          mobile: this.pwdForm.mobile
        })
        if (res.data.statusCode === '200') {
          if (res.data.result.length === 0) {
            throw new Error('手机号未注册')
          }
          this.accounts = res.data.result
          // this.pwdForm.username = this.accounts[0].username
          this.pwdForm.username = this.userInfo.username
        } else {
          throw new Error(res.data.message)
        }
      } catch (error) {
        this.$message({
          message: error.message,
          type: 'error'
        })
      }
    },
    async onSubmit () {
      // if (!this.pwdForm.mobile) {
      //   this.$message('请输入手机号码')
      //   return
      // }
      // if (!this.pwdForm.code) {
      //   this.$message('请输入验证码')
      //   return
      // }
      // if (!this.pwdForm.password) {
      //   this.$message('请输入密码')
      //   return
      // }
      // if (!this.pwdForm.rePassWord) {
      //   this.$message('请确认密码')
      //   return
      // }
      // if (this.pwdForm.password !== this.pwdForm.rePassWord) {
      //   this.$message('两次输入的密码不一致')
      //   return
      // }
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            this.pwdForm.username = this.userInfo.username
            const res = await API.updatePwd(this.pwdForm)
            this.$message({
              message: res.data.result,
              type: 'success'
            })
          } catch (e) {

          } finally {
            this.loading = false
          }
        }
      })
    },
    // 获取AuthCode
    setNewAuthCode (newVal) {
      this.pwdForm.code = newVal
    }
  },
  components: {
    AuthCode
  }
}
</script>

<style lang="stylus">
.password
  height 666px
  box-sizing border-box
  background-color #ffffff
  overflow hidden
  .pwd-form-wrapper
    width 500px
    height 600px
    box-sizing border-box
    padding 40px 0 0 40px
    .u-pwd-auth-c
      // 重写element按钮样式
      .el-input-group__append
        background-color #31A826
        .auth-code-btn
          color #ffffff
          background-color #31A826
    .btn
      margin-top 30px
</style>
